import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { CompanyQueryKey } from './queryKey';
export const useUpdateCompany = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.put('/api/company/Put', model).then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([CompanyQueryKey.Companies], (old) => {
                if (!old)
                    return old;
                return old.map(c => (c.id === result.id ? Object.assign(Object.assign({}, c), result) : c));
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateCompany: mutateAsync, isUpdating: isLoading };
};
